import type { AuthSession } from '@updater/auth';

type Settings = {
  expiresAt: Date;
};

export const Session = {
  read() {
    try {
      const session = JSON.parse(window.sessionStorage.getItem('session')!);
      if (!session.expiresAt || session.expiresAt <= new Date()) {
        window.sessionStorage.removeItem('session');
      }
      return session;
    } catch (e) {}
  },

  write(session?: AuthSession) {
    if (session) {
      const settings: Settings = {
        expiresAt: new Date(new Date().getTime() + 45 * 60 * 1000),
      };
      window.sessionStorage.setItem(
        'session',
        JSON.stringify({ ...session, ...settings })
      );
    } else window.sessionStorage.removeItem('session');
  },
};
